import { getRoleLabel } from '../../constants/roles';

const WORK_SITE_ROLES = new Set([
  'head doctor',
  'doctor',
  'nurse',
  'major',
  'receptionist',
  'pharmacist',
  'admin pharmacist'
]);

export function formatUserDisplayName(user) {
  const last = (user?.last_name || '').trim();
  const first = (user?.first_name || '').trim();
  if (last && first) return `${last} ${first}`;
  if (last) return last;
  if (first) return first;
  if (user?.username) return user.username;
  return `Compte #${user?.id ?? '?'}`;
}

export function formatUserMetaLine(user) {
  const parts = [];
  const last = (user?.last_name || '').trim();
  const first = (user?.first_name || '').trim();
  const hasName = Boolean(last || first);

  if (hasName && user?.username) {
    parts.push(`@${user.username}`);
  }
  if (user?.email) {
    parts.push(user.email);
  } else if (user?.phone) {
    parts.push(user.phone);
  }

  return parts.join(' · ');
}

export function formatWorkSitesSummary(workSiteIds, workSiteNameById, role) {
  if (!WORK_SITE_ROLES.has(role)) {
    return { text: '—', title: 'Aucun site requis pour ce rôle', empty: true };
  }

  const ids = Array.isArray(workSiteIds) ? workSiteIds : [];
  if (ids.length === 0) {
    return { text: 'Aucun site', title: 'Site de travail non renseigné', empty: true, warn: true };
  }

  const names = ids.map((id) => workSiteNameById[String(id)] || `Site #${id}`);
  const title = names.join(', ');

  if (names.length <= 2) {
    return { text: names.join(', '), title, empty: false };
  }

  return {
    text: `${names.slice(0, 2).join(', ')} +${names.length - 2}`,
    title,
    empty: false
  };
}

export function getUserRoleLabel(role) {
  return getRoleLabel(role) || role || '—';
}

export function userRoleCssKey(role) {
  return (role || 'unknown').replace(/\s+/g, '-');
}
